module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Thanks to all my family members who offered words of wisdom and encouragement. Special thanks to fellow Doyle family members who had first review of drafts and thoughts and guidance: Terry, Vicki and Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks also to my first-read cousin, Mary Alice, for bearing the brunt of first passes in all the gyrations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to "), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_vm._v("Ancestry.com")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://Newspapers.com",
      "target": "_blank"
    }
  }, [_vm._v("Newspapers.com")]), _vm._v(" for their invaluable sources and research capabilities that guided this work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, thanks to all the kingpins who provided valuable inspiration for achievement.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0aab5a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 75
// module chunks = 0